import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TagsDashboardQueryKeys } from "modules/TagsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { TagFormPayload } from "modules/TagsDashboard/components/TagModal/hooks/useCreateTagMutation";

type UpdateTagsPayload = {
  tags: TagFormPayload[];
};

export const useUpdateTagsMutation = () =>
  useTypedMutation<UpdateTagsPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/tags/update", payload, ENV.systemBaseURL);
    },
    onSuccess: ({ tags: [updatedTag] }) => {
      const previousTags = typedQueryClient.getQueryData(TagsDashboardQueryKeys.tags);
      if (!previousTags) return;

      const tagIdx = previousTags.findIndex(tag => tag.id === updatedTag.id);
      if (tagIdx === -1) return;

      typedQueryClient.setQueryData(
        TagsDashboardQueryKeys.tags,
        previousTags.with(tagIdx, { ...previousTags[tagIdx], ...updatedTag, updated_on: toISOString(new Date()) })
      );
    }
  });
